import React from 'react'

import {
  Table,
} from 'components/UI'
import UserEditButton from './UserEditButton'
import UserCreateButton from './UserCreateButton'

function fullName (first, last, email) {
  if (first || last) {
    return `${first || ''} ${last || ''}`
  } else {
    return email
  }
}

const UserTable = ({ data, refetch, organizationId, buildings }) => {
  const columns = [{
    Header: (
      <UserCreateButton
        onSuccess={refetch}
        organizationId={organizationId}
      />
    ),
    columns: [{
      accessor: row => row,
      id: 'edit',
      sortable: false,
      resizable: false,
      width: 100,
      Cell: ({ value }) => (
        <UserEditButton
          onSuccess={refetch}
          userId={value.id}
          role={value.role}
          organizationId={organizationId}
        />
      ),
    }, {
      Header: 'User Name',
      id: 'name',
      width: 200,
      accessor: row => fullName(row.givenName, row.familyName, row.email),
    }, {
      Header: 'User Group',
      accessor: 'role',
    }, ...(organizationId ? [] : [{
      Header: 'Organization',
      accessor: 'organization.name',
      width: 200,
    }]), {
      Header: 'No. of Buildings',
      accessor: organizationId ? 'buildings.length' : 'organization.buildings.length',
    }],
  }]
  
  return (
    <Table
      data={data}
      columns={columns}
    />
  )
}

export default UserTable



// WEBPACK FOOTER //
// ./src/components/Profile/UserTable.jsx